export const getErrorMessage = (getI18n:any,errorCode: any,data:any): any => {
    switch (errorCode) {
        case 'successAddFav':
            return '« '+[data.message?.params?.title]+' » ' + getI18n()?.formatMessage({id: 'FAVORITIES_ADDED'})
        case 'successRemoveFav':
            return '« '+[data.message?.params?.title]+' » ' + getI18n()?.formatMessage({id: 'FAVORITIES_REMOVED'})
        case 'addFavoriteChannelSuccess':
            return '« '+[data.message?.params?.name]+' » ' + getI18n()?.formatMessage({id: 'FAVORITIES_ADDED'})
        case 'removeFavoriteChannelSuccess':
            return '« '+[data.message?.params?.name]+' » ' + getI18n()?.formatMessage({id: 'FAVORITIES_REMOVED'})
        case 'deleteBackendDeviceSuccess':
            return getI18n()?.formatMessage({id: 'IS_REMOVED_SUCCESSFULLY'}, {title: data.message?.params?.title})
        case 'deleteBackendDeviceFailed':
            return getI18n()?.formatMessage({id: 'CANNOT_BE_REMOVED'}, {title: data.message?.params?.title})
        case 'deleteBackendDeviceError':
            return getI18n()?.formatMessage({id: 'CANNOT_BE_REMOVED'}, {title: data.message?.params?.title})
        case 'pinCodeUpdatedSuccess':
            return getI18n()?.formatMessage({id: 'PARENTAL_PIN_UPDATE_SUCCESS_MSG'})
        case 'addFavoriteSuccess':
            return '« '+[data.message?.params?.title]+' » ' + getI18n()?.formatMessage({id: 'FAVORITIES_ADDED'})
        case 'deleteFavoriteSuccess':
            return '« '+[data.message?.params?.title]+' » ' + getI18n()?.formatMessage({id: 'FAVORITIES_REMOVED'})
        case 'cancelRecordingSuccess':
            return  getI18n()?.formatMessage({id: 'CANCEL_RECORDING'}, {title: data.message?.params?.title})
        case 'cancelRecordingError':
            return  getI18n()?.formatMessage({id: 'CANCEL_RECORDING_ERROR'}, {title: data.message?.params?.title})
        case 'deleteRecordingSuccess':
            return  getI18n()?.formatMessage({id: 'DELETE_RECORDING_SUCCESS'}, {title: data.message?.params?.title})
        case 'deleteRecordingError':
            return  getI18n()?.formatMessage({id: 'DELETE_RECORDING_ERROR'}, {title: data.message?.params?.title})
        case 'addRecordingSuccess':
            return  getI18n()?.formatMessage({id: 'RECORDING_STARTED'}, {title: data.message?.params?.title})
        case 'addRecordingTvSuccess':
            return  getI18n()?.formatMessage({id: 'TV_RECORDING_STARTED'}, {title: data.message?.params?.title})
        case 'addRecordingError':
            return  getI18n()?.formatMessage({id: 'RECORDING_CAN_NOT_STARTED'})
        case 'switchBackToPlayer':
        return  getI18n()?.formatMessage({id: 'SWITCH_BACK_TO_PLAYER'})
        case 'setReminderAlertBeforeSuccess':
            return getI18n()?.formatMessage({ id: 'notification.setReminderAlertBeforeSuccess' }, {title: '« '+ data.message?.params?.title +' » ' })
        case 'setReminderSuccess':
            return getI18n()?.formatMessage({ id: 'notification.setReminder.success' }, {title: '« '+ data.message?.params?.title +' » '})
        case 'setReminderError':
            return getI18n()?.formatMessage({ id: 'notification.setReminder.error' }, {title: data.message?.params?.title})
        case 'unsetReminderAlertBeforeSuccess':
            return getI18n()?.formatMessage({ id: 'notification.unsetReminderAlertBeforeSuccess' }, {title: '« '+ data.message?.params?.title +' » ' })
        case 'unsetReminderSuccess':
            return getI18n()?.formatMessage({ id: 'notification.unsetReminder.success' }, {title: '« '+ data.message?.params?.title +' » '})
        case 'unsetReminderError':
            return getI18n()?.formatMessage({ id: 'notification.unsetReminder.error' }, {title: data.message?.params?.title})
        case 'RECORDING_EXCEEDED_QUOTA':
            return getI18n()?.formatMessage({id: 'RECORDING_EXCEEDED_QUOTA'})
        case 'MAX_DEVICES_REACHED':
            return getI18n()?.formatMessage({id: 'MAX_DEVICES_REACHED'})
        case 'redeemVoucherCodeSuccess':
            return getI18n()?.formatMessage({id: 'REDEEM_VOUCHER_CODE_SUCCESS'})
        case 'vodRentPurchaseSuccess':
            return getI18n()?.formatMessage({id: 'VOD_RENT_PURCHASE_SUCCESS'}, {title: data.message?.params?.title})
        case 'redeemVoucherCodeFailure':
            if(data.message?.params?.description?.includes("CONFLICT")){
                return getI18n()?.formatMessage({id: 'REDEEM_VOUCHER_CODE_CONFLICT'})
            }
            else{
                return data.message?.params?.title
            }
        case 'unsupportedBrowserDetected':
            return getI18n()?.formatMessage({id: 'UnsupportedBrowserMessage'})
        // case 'GENERATE_OTP_100': 
        //     return getI18n()?.formatMessage({id: 'ERROR_GENERATE_OTP_100'})
        // case 'GENERATE_OTP_101': 
        //     return getI18n()?.formatMessage({id: 'ERROR_GENERATE_OTP_101'})
        // case 'GENERATE_OTP_110': 
        //     return getI18n()?.formatMessage({id: 'ERROR_GENERATE_OTP_110'})
        // case 'GENERATE_OTP_102': 
        //     return getI18n()?.formatMessage({id: 'ERROR_GENERATE_OTP_102'})
        // case 'GENERATE_OTP_103': 
        //     return getI18n()?.formatMessage({id: 'ERROR_GENERATE_OTP_103'})
        // case 'GENERATE_OTP_104': 
        //     return getI18n()?.formatMessage({id: 'ERROR_GENERATE_OTP_104'})
        // case 'GENERATE_OTP_105': 
        //     return getI18n()?.formatMessage({id: 'ERROR_GENERATE_OTP_105'})
        // case 'GENERATE_OTP_106': 
        //     return getI18n()?.formatMessage({id: 'ERROR_GENERATE_OTP_106'})
        // case 'GENERATE_OTP_107': 
        //     return getI18n()?.formatMessage({id: 'ERROR_GENERATE_OTP_107'})
        // case 'GENERATE_OTP_111': 
        //     return getI18n()?.formatMessage({id: 'ERROR_GENERATE_OTP_111'})
        // case 'VERIFY_OTP_101': 
        //     return getI18n()?.formatMessage({id: 'ERROR_VERIFY_OTP_101'})
        // case 'VERIFY_OTP_100': 
        //     return getI18n()?.formatMessage({id: 'ERROR_VERIFY_OTP_100'})
        // case 'VERIFY_OTP_102': 
        //     return getI18n()?.formatMessage({id: 'ERROR_VERIFY_OTP_102'})
        case 'PURCHASE_FAILED_DUE_EXISTING_ENTITLEMENT, PURCHASE_PRODUCT_FAILED, 708-UFI, ': {
            return getI18n()?.formatMessage({id: 'PURCHASE_FAILED_DUE_EXISTING_ENTITLEMENT'})
        }
        case 'programsLoading':
            return getI18n()?.formatMessage({ id: 'PROGRAM_LOADING_TEXT' })
        default:
            const navTags = [];
            for (let i = 700; i <= 728; i++) {
                navTags.push(`NAV-${i}`);
            }
            if (navTags.includes(data?.message?.tag?.[2])) {
                return data?.message?.tag?.[2];
            }

            if (data?.message?.tag?.includes?.("PIN_GENERATION_LIMIT")) {
                return '';
            }

            return data?.message?.params?.title ?? errorCode
    }
}